module.exports = __webpack_public_path__ + "img/progressDetil.1d49cee5.jpg";